// modules/OrderingButton.js
import React         from 'react';

class OrderingButton extends React.Component {
	render() {
			return (
				<div className="lfsb-orderbutton" onClick={(e) => this.props.onClick(e)}>
						{this.props.children}
						<svg className="lfss-filterchevron i-posa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 140">
							<path className={`lfss-filterchevron-path lfss-${this.props.btype}-desc ${this.props.filterby.type} ${this.props.filterby.order}`} d="M7.8,83.2l-6.6,6.2l48,50.5l49.1-49.4l-6.4-6.4L49.3,127L7.8,83.2z"/>
							<path className={`lfss-filterchevron-path lfss-${this.props.btype}-asc ${this.props.filterby.type} ${this.props.filterby.order}`} d="M91.8,56.1l6.5-6.4L49.5,0L1.2,50.2l6.5,6.3L49.5,13L91.8,56.1z"/>
						</svg>
				</div>
			);
	}
}

export default OrderingButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/OrderingButton.js
 **/